import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_COMMITTEES_LOAD,
    ACTION_COMMITTEES_LOAD_BY_ID,

    ACTION_COMMITTEES_SAVE,

    ACTION_COMMITTEES_CREATE,

    ACTION_COMMITTEES_VALIDATE,

    ICommitteeLoadAction,
    ICommitteeLoadByIdAction,
    ICommitteeLoadFailureAction,
    ICommitteeLoadSuccessAction,

    ICommitteeSaveAction,
    ICommitteeSaveSuccessAction,
    ICommitteeSaveFailureAction,

    ICommitteeCreateAction,
    ICommitteeCreateSuccessAction,
    ICommitteeCreateFailureAction,

    ICommitteeValidateAction,
    ICommitteeValidateSuccessAction,
    ICommitteeValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/committees";
import { committeesApi } from "../services/committees";


export const
    getCommitteesEpic = (action$): Observable<ICommitteeLoadSuccessAction | ICommitteeLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEES_LOAD)
            .mergeMap((_action: ICommitteeLoadAction) => {
                return committeesApi
                    .getCommittees()
                    .map(response =>
                        LoadSuccess(response.committees, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getCommitteeByIdEpic = (action$): Observable<ICommitteeLoadSuccessAction | ICommitteeLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEES_LOAD_BY_ID)
            .mergeMap((action: ICommitteeLoadByIdAction) => {
                return committeesApi
                    .getCommitteeById(action.id)
                    .map(response =>
                        LoadSuccess(response.committee, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setCommitteeEpic = (action$): Observable<ICommitteeSaveSuccessAction | ICommitteeSaveFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEES_SAVE)
            .mergeMap((action: ICommitteeSaveAction) => {
                return committeesApi
                    .setCommittee(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.committee, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createCommitteeEpic = (action$): Observable<ICommitteeCreateSuccessAction | ICommitteeCreateFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEES_CREATE)
            .mergeMap((_action: ICommitteeCreateAction) => {
                return committeesApi
                    .createCommittee()
                    .map(response =>
                        CreateSuccess(response.committee, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateCommitteeEpic = (action$): Observable<ICommitteeValidateSuccessAction | ICommitteeValidateFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEES_VALIDATE)
            .mergeMap((action: ICommitteeValidateAction) => {
                return committeesApi
                    .validateCommittee(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.committee, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



